import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import { components } from '@glowingblue-orell-thalia-common';
import HomeStats from './components/HomeStats';
import CurrentlyOnlineStat from './components/CurrentlyOnlineStat';

export default function addHomeStats() {
	if (!app.initializers.has('glowingblue-orell-thalia-common')) return;

	extend(components.HomePage.prototype, 'welcomeBlocks', function (blocks: any) {
		blocks.add('stats', <HomeStats />, 90);
	});

	extend(components.CustomFooter.prototype, 'statsItems', function (items: any) {
		items.add('currentlyOnline', <CurrentlyOnlineStat />, 100);
	});
}
